module.exports = __webpack_public_path__ + "static/media/pointing-at-amanda.6f64131e.jpg";